import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { LastAddedVenue } from '../../../../models/lastActions';
import { VenueListingItem } from '../../../../models/listing';

@Component({
  selector: 'last-added-card',
  templateUrl: './last-added-card.component.html',
  styleUrls: ['../../homeselected/selected-card/selected-card.component.css','./last-added-card.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class LastAddedCardComponent implements OnInit {
  @Input() venueData: LastAddedVenue;
  venueTypes: string[] = [];
  constructor() { }

  ngOnInit(): void {
    this.venueTypes = this.venueData.types.split(',');
  }
  getLargerImage(imgLink: string): string{
    let newLink = imgLink.replace('thumb','medium');
    return newLink;
  }

}
